export const config = { baseUrl: process.env.REACT_APP_BACKEND_BASE_URL };
